/**
 * Created by zoupeiyang on 2017/9/19.
 */

let globalData = {};
//接收云端信息
globalData.systemInfo = {};

//商家信息
globalData.enterpriseInfo = {};
//终端所属门店的信息
globalData.storeInfo = {};
//终端信息
globalData.devInfo = {};
//API信息
globalData.apiInfo = {};

globalData.enterpriseInfo.BrankName = "天羚自助演示系统";
globalData.enterpriseInfo.BrandLogo = "../../../static/image/tllogo.png";
globalData.enterpriseInfo.wxAccountIsSet = true;
globalData.enterpriseInfo.wxQrCode = "../../../static/image/qrcode.jpg";



globalData.storeInfo.storeAd = "../../../static/image/offLine/off-line-ad2.jpg";
globalData.storeInfo.products = new Array();
globalData.storeInfo.selectedProducts = new Array();
globalData.storeInfo.selectedRecharge = {};

//现金支付信息
globalData.cashPayInfo = {};
globalData.cashPayInfo.payMoney = 0;
globalData.cashPayInfo.receiveMoney = 0;
globalData.cashPayInfo.payFinishFlag = 0;
globalData.cashPayInfo.callBackInitFlag = 0;
globalData.cashPayInfo.payLog = "";


//倒计时
globalData.devInfo.countDownTime = 120;
globalData.devInfo.homePage = "/";
//天羚终端系统版本{myBase基础版，myFull美业全屏版本}
globalData.devInfo.tlVersion = "/myFull";
globalData.devInfo.weatherInfo = "";
globalData.devInfo.onLine = true;
globalData.devInfo.debug = false;
globalData.devInfo.devSn = "";
globalData.devInfo.cashMsg = "本机接收纸币1元、5元、10元、20元";
globalData.devInfo.cashCode = 1 + 2 + 4 + 8;
globalData.devInfo.payType = 1; //支付方式，0表现金支付，1表示支付宝扫码支付，2表示微信扫码支付，3表示会员卡支付，4表示银行卡支付，5表示公众号微信支付
globalData.devInfo.selectedProducts = new Array();
globalData.devInfo.imagePath = "http://image.tl-self.com";
globalData.devInfo.memberUid = "";
globalData.devInfo.tradeType = 1; //0表示充值，1表示消费购买
globalData.devInfo.SettleNo = ""; //结算单号
globalData.devInfo.devSn = ""; //终端唯一序列号
globalData.devInfo.tlKey = "mO3p4Qj81q8DwRil";
globalData.devInfo.rsaPublicKey = "";
globalData.devInfo.SelectWay = 1; //1表示堂食，2表示外带
//当前页面是否允许打开系统设置，0表示允许，1表示禁止，如投币页面禁止打开设置页面
globalData.devInfo.setOpen = 0;
globalData.devInfo.remarkName = ""; //口味
globalData.devInfo.deskNum = ""; //台号
globalData.devInfo.lunchBoxNum = 0; //饭盒数量
globalData.devInfo.idCardInfos = new Array(); //身份证信息

//最大排队号
globalData.devInfo.maxQueueNumber = 1;
globalData.devInfo.systemSetUp = {};
globalData.devInfo.systemSetUp.show_line_up = false;
globalData.devInfo.systemSetUp.language = "zh-CN";
globalData.devInfo.systemSetUp.print_queue_number = true;
globalData.devInfo.systemSetUp.print_qr_code = true;
globalData.devInfo.systemSetUp.theme = "default";
globalData.devInfo.systemSetUp.price_show_plan = 0;
//语音播报声音性别，0为女声，1为男声音
globalData.devInfo.systemSetUp.sound_sex = 0;

globalData.version = "V2089";







global.LOCAL_DATA = globalData;


// WEBPACK FOOTER //
// ./src/assets/js/grobalData.js